import { render, staticRenderFns } from "./SystemPermissionGroupManage.vue?vue&type=template&id=65e30d58&scoped=true"
import script from "./SystemPermissionGroupManage.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e30d58",
  null
  
)

export default component.exports